import React from 'react';
import { Auth0Provider, ICache, AuthorizationParams } from '@auth0/auth0-react';
import { RouterRoot } from './router';
import { AUTHORIZATION, API } from './constants';

import './global.css';

const cache: ICache = {
    async set(key, value){
        localStorage.setItem(key, JSON.stringify(value));
    },
    async get(key: string){
        const object = localStorage.getItem(key);
        return Promise.resolve(object ? JSON.parse(object) : undefined);
    },
    async remove(key: string){
        localStorage.removeItem(key);
    }
};

const authorizationParams: AuthorizationParams = {
    redirect_uri: AUTHORIZATION.REDIRECT_URI,
    audience: AUTHORIZATION.AUDIENCE,
    scope: AUTHORIZATION.SCOPE
};

const auth0Params = {
    domain: API.DOMAIN,
    clientId: API.CLIENT_ID,
    authorizationParams: authorizationParams,
    cache: cache
};

const Application = () => {
    return (
        <Auth0Provider {...auth0Params}>
            <RouterRoot/>
        </Auth0Provider>
    );
};

export default Application;
